import React from 'react';
import styles from './TextGroupSectionA.module.sass';
import TextContainer from '../../reusable/title_description_group_container/TitleDescriptionGroupContainer';
import { TextGroupStyle } from '../../reusable/title_description_group/TitleDescriptionGroup';
import MobileSpacer, { SpacerSize } from '../../reusable/mobile_spacer/MobileSpacer';
import Jen from '../../assets/jen.webp';
import Grid from '../../reusable/grid/Grid';
import RevealImage from '../../reusable/reveal/RevealImage';

const title = "Jennifer Morgan."
const subtitle = "Founder & Pediatric Occupational Therapist"
const paragraphs = [
  "Jennifer Morgan is a pediatric occupational therapist with more than 16 years of experience practicing occupational therapy, and many more years of experience working with children in a variety of settings. A native of Los Angeles, Jennifer received her Master's Degree in Occupational Therapy from the University of Southern California, where she received a federally funded grant to train as a school based and early childhood practitioner.",
  "Jennifer founded MOST Kids OT in Malibu in 2013, after spending years working as the lead Occupational Therapist for all Malibu public schools, and feeling dissatisfied with the level of flexibility and creativity the school district allowed. At MOST, Jennifer has been able to utilize her innate talent, specialized training, and experience to help each child succeed. In 2015, Jennifer expanded her services by instituting the Occupational Therapy program at Park Century School, an independent school dedicated to providing individualized education for students with learning differences. Jennifer and her team are continuously expanding, creating in-house OT programs and providing services at well-established private Los Angeles based schools, including Curtis School and Seven Arrows Elementary School, among others."
]

export default class TextGroupSectionA extends React.Component {

  render() {
    return (
      <div>
        <MobileSpacer size={SpacerSize.medium} />
        <RevealImage className={styles.Jen} src={Jen} photo />
        <Grid>
          <TextContainer
            className={styles.TextContainer}
            dark={true}
            title={title}
            subtitle={subtitle}
            paragraphs={paragraphs}
            style={TextGroupStyle.small} />
        </Grid>
      </div>
    )
  }

}
